import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";

import { request } from "./request";
import { AuthenticationContext } from "../context";
import { RecentActivityFilters, RecentActivityReturnTypes } from "../constants/constants";

export type ActivityTypeMap = RecentActivity & {
  readonly title: string,
  readonly description: JSX.Element | string,
  readonly link: () => void
}

interface RecentActivityData {
  readonly outcome?: string;
  readonly drug_name?: string;
  readonly date_of_service?: string;
  readonly patient_pay_amount?: number;
  readonly plan_pay_amount?: number;
  readonly type?: string;
  readonly minimum_service_date?: string;
  readonly maximum_service_date?: string;
  readonly status?: string;
  readonly billing_provider_first_name?: string;
  readonly billing_provider_last_name_or_organizational_name?: string;
  readonly total_patient_pay_amount?: number;
  readonly total_plan_pay_amount?: number;
}

interface RecentActivity {
  readonly id: string;
  readonly data: RecentActivityData;
  readonly sortable_date: string;
  readonly type: RecentActivityReturnTypes;

}

interface MemberDashboardActivitiesRequest {
  readonly recent_activity_filters?: Array<RecentActivityFilters>;
  readonly person_code?: string;
}

interface MemberDashboardActivitiesResponse {
  readonly results: Array<RecentActivity>;
  readonly result_count: string;
}


export const listMemberRecentActivity = async (authToken: string | undefined, body: MemberDashboardActivitiesRequest) => {
  return request<MemberDashboardActivitiesRequest, MemberDashboardActivitiesResponse>(
    {
      endpoint: "/member/recent_activity",
      body: { ...body },
    },
    authToken,
  );
};

export const useGetMemberRecentActivityDataQuery = (body?: MemberDashboardActivitiesRequest) => {
  const { getAuthToken } = useContext(AuthenticationContext);
  const query = useQuery({
    queryFn: async () => listMemberRecentActivity(await getAuthToken(), { ...body }),
    queryKey: ["priorAuthorizationList", body?.person_code, body?.recent_activity_filters || null],
  });

  return query;
};
